import { ProcessorInfo } from 'features/VirtualBackground/types';
import { virtualBackgroundStore } from '../store/virtualBackground';

export const selectIsVirtualBackgroundEnabled = (): boolean => virtualBackgroundStore.isVirtualBackgroundEnabled;
export const selectIsBackgroundProcessorLoading = (): boolean => virtualBackgroundStore.isBackgroundProcessorLoading;
export const selectAvailableProcessors = () => virtualBackgroundStore.availableProcessors;
export const selectActiveProcessor = (): string | null => virtualBackgroundStore.activeProcessor;

export const selectActiveProcessorInfo = (): ProcessorInfo | null => {
    const activeProcessor = selectActiveProcessor();
    if (!activeProcessor) return null;

    const availableProcessors = selectAvailableProcessors();

    return availableProcessors.get(activeProcessor) || null;
};
